import { render, staticRenderFns } from "./LatestStatment.vue?vue&type=template&id=0cb4473c"
import script from "./LatestStatment.vue?vue&type=script&lang=js"
export * from "./LatestStatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports